export default __webpack_public_path__ + "static/media/quant.6c17e4d4.svg";